import { LifestyleManageGroupPageTemplate } from "./template";
import { useLifestyleManageGroupPage } from "./logic";

export const LifestyleManageGroupPage = (): JSX.Element => {
  const templateProps = useLifestyleManageGroupPage();
  return <LifestyleManageGroupPageTemplate {...templateProps} />;
};
